//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { CancelToken, AxiosRequestConfig, AxiosInstance } from 'axios';
import { BusinessObjectType } from '../../../Core/BusinessObjectType';
import DefaultDtoControllerProxy from './DefaultDtoControllerProxy';
import { IContactCategoryDTO } from '../../../DTO/IContactCategoryDTO';

//element.Name=ContactCategoryController result.Name=ContactCategoryController element.FullName=Digita.Tustena.UIApiControllers.BusinessObject.DTO.ContactCategoryController);
/** WebApiController: ContactCategoryController */
export class ContactCategoryController extends DefaultDtoControllerProxy<IContactCategoryDTO>
{
	constructor (axios: AxiosInstance)
	{
		super(axios, 'ContactsCategories', BusinessObjectType.ContactCategory);
	}
	public GetFull(id: number, cancelToken?: CancelToken, axiosConfig?: AxiosRequestConfig) : Promise<IContactCategoryDTO>
	{
		return (this.axios.get('ContactsCategories/GetFull?&id='+id, { ...axiosConfig, cancelToken })).then(r => r.data);
	}
}
